module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/server-header.aecb81c7.jpg";